import React, { useEffect, useRef } from 'react'
import useStateRef from 'react-usestateref'

const HubSpotModal = () => {
    const [url, setUrl, urlRef] = useStateRef("")

    useEffect(() => {
        document.querySelector('#hubSpotModal').addEventListener('show.bs.modal', function (e) {
            if(document.getElementById("hubspotBody")){
                document.getElementById("hubspotBody").innerHTML=`<iframe id="hubSpotIFrame" style="height: 785px;width:100%"  src="/hubSpotForm?portalId=44059706&formId=1a35fe82-646c-4770-99e5-c70883527d20&region=na1" />`
            }
            setUrl("/hubSpotForm?portalId=44059706&formId=1a35fe82-646c-4770-99e5-c70883527d20&region=na1");
        })
        document.querySelector('#hubSpotModal').addEventListener('hidden.bs.modal', function (e) {
            if(document.getElementById("hubspotBody")){
                document.getElementById("hubspotBody").innerHTML=``
            }
            setUrl("");
        })

    }, [])



    return (
        <div>



            <div id="hubSpotModal" class="modal fade  c-modal" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">

                <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a modal-lg-b">
                    <div class="modal-content" >
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        </button>
                        <div class="modal-body" id="hubspotBody">
                            {/* {urlRef.current ?
                                <iframe id="hubSpotIFrame" style={{ "height": "785px", "width": "100%" }} src={urlRef.current} />
                                : ""} */}

                        </div>
                    </div>
                </div>


            </div>





        </div>
    )
}

export default HubSpotModal